class ConfiguracaoPisCofinsModal {

    constructor(gql, $scope, $sce, $filter, parametrosTributarios) {
        this.gql = gql
        this.parametrosTributarios = parametrosTributarios
        this.apply = fun => $scope.$apply(fun)
        this.overlaps = []
        this.$sce = $sce
        this.$filter = $filter
        this.hasChange = false

        this.onClose = () => {
            this.parametrosTributarios
                .getPisCofinsVigente(this.empresa)
                .then(pisCofins => this.close({ $value: { pisCofins } }))
                .catch(() => this.close())
        }
    }

    $onInit() {
        this.promise = this
            .loadEmpresa()
            .then(empresa => {
                this.empresa = empresa
                this.pisCofins = empresa.pisCofinsVigente
            })
    }

    loadEmpresa() {
        const query = gql`
            query Filial {
                empresa: filial(id: ${this.resolve.filialId}) {
                    id
                    pisCofins {
                        id
                        aliquotaPis
                        aliquotaCofins
                        atividade
                        vigencia {
                            from
                            to
                        }
                        regimeTributario {
                            id
                        }
                    }
                    pisCofinsVigente {
                        id
                    }
                }
            }
        `

        return this
            .gql
            .query(query, {})
            .then(({ empresa: { pisCofins, pisCofinsVigente, ...empresa } }) => {
                pisCofins = pisCofins
                    .map(pc => this.formatPisCofins(pc))
                    .sort(({ vigencia }, { vigencia: vigencia2 }) =>
                        this.parametrosTributarios.sortVigencia(vigencia, vigencia2)
                    )

                pisCofinsVigente = pisCofinsVigente && pisCofins.find(p => p.id === pisCofinsVigente.id)

                return {
                    ...empresa,
                    pisCofinsVigente,
                    pisCofins
                }
            })
    }

    removePisCofins(pisCofins) {
        Confirm.warning('Atenção', 'Deseja realmente remover essa configuração PIS/COFINS?', {
            'Não': angular.noop,
            'Sim': () => {
                this.promise = this.parametrosTributarios
                    .deleteFilialPisCofins(this.resolve.empresaId, pisCofins)
                    .then((pisCofins) => {
                        this.empresa.pisCofins = this.empresa.pisCofins.reject(p => p.id === pisCofins.id)
                        this.pisCofins = null
                    })
                    .then(() => this.apply())

                this.apply()
            }
        })
    }

    onChange(pisCofins) {
        this.hasChange = !this.isPisCofinsEquals(pisCofins, this.pisCofins)

        if (this.submitted) {
            this.overlaps = this.empresa.pisCofins
                .reject(p => p.id === pisCofins.id)
                .filter(p =>
                    this.parametrosTributarios
                        .isOverlap(pisCofins.vigencia, p.vigencia)
                )
        }
    }

    onErrors(pisCofins) {
        this.submitted = true
        this.onChange(pisCofins)
    }

    afterUpdatePisCofins(pisCofins) {
        pisCofins = this.formatPisCofins(pisCofins)
        this.hasChange = false

        this.empresa.pisCofins = [pisCofins, ...this.empresa.pisCofins]
            .uniqBy(p => p.id)
            .sort((p1, p2) => this.parametrosTributarios.sortVigencia(p1.vigencia, p2.vigencia))

        this.pisCofins = pisCofins
    }

    formatPisCofins({ regimeTributario, aliquotaPis, aliquotaCofins, ...rest }) {
        return {
            ...rest,
            aliquotaPis: parseFloat(aliquotaPis),
            aliquotaCofins: parseFloat(aliquotaCofins),
            regimeTributarioId: regimeTributario.id
        }
    }

    isPisCofinsEquals(pisCofins1, pisCofins2) {
        const toList = p => {
            const { aliquotaPis, aliquotaCofins, regimeTributarioId, atividade, vigencia } = p

            return [
                aliquotaPis,
                aliquotaCofins,
                regimeTributarioId,
                atividade,
                vigencia && vigencia.from,
                vigencia && vigencia.to
            ]
        }

        pisCofins1 = toList(pisCofins1)
        pisCofins2 = toList(pisCofins2)

        return JSON.stringify(pisCofins1) === JSON.stringify(pisCofins2)
    }

    selectPisCofins(pisCofins = {}) {
        const select = () => {
            this.pisCofins = pisCofins
            this.submitted = false
            this.hasChange = false
            this.overlaps = []
        }

        const warning = () => {
            Confirm.warning('Atenção', 'Algumas configurações não foram salvas, deseja realmente trocar de configuração?', {
                'Não': angular.noop,
                'Sim': () => {
                    select()
                    this.apply()
                }
            })
        }

        if (this.hasChange) {
            warning()
        } else {
            select()
        }
    }

    hasConflict(pisCofins) {
        return this.overlaps.some(p => p.id === pisCofins.id)
    }

    get gaps() {
        return this.empresa
            ? this.parametrosTributarios.getGaps(this.empresa.pisCofins)
            : []
    }

    get gapTooltipContent() {
        const html = this.gaps
            .reduce((acc, gap) => {
                return `
                    ${acc}
                    <div>${gap.from ? this.$filter('date')(gap.from, 'dd/MM/yyyy') : '...'} a ${gap.to ? this.$filter('date')(gap.to, 'dd/MM/yyyy') : '...'}</div>
                `
            }, '')

        return this.$sce.trustAsHtml(html)
    }
}

angular
    .module('eficienciaFiscalModule')
    .component('configuracaoPisCofinsModal', {
        controller: ['gql', '$scope', '$sce', '$filter', 'ParametrosTributarios', ConfiguracaoPisCofinsModal],
        bindings: {
            close: '&',
            resolve: '<'
        },
        template: `
            <promise-tracker promise="$ctrl.promise" active="isLoading">
                <modal modal-title="Configurações de PIS/COFINS" close="$ctrl.onClose">
                    <modal-body>
                        <div class="pis-cofins-container">                            
                            <div class="pis-cofins-list"> 
                                <button ng-click="$ctrl.selectPisCofins()" class="btn btn-info btn-block">Adicionar configuração</button>
                                <div 
                                    class="text-center text-muted" 
                                    ng-if="!$ctrl.empresa.pisCofins.length" 
                                    style="text-align: center;margin-top: 13px;">
                                    <span>Nenhuma configuração de PIS/COFINS encontrada.</span>
                                </div>
                                <div 
                                    ng-if="$ctrl.gaps.length" 
                                    class='help-block text-center txt-color-red font-xs'
                                    tooltip-placement='right'
                                    tooltip-html-unsafe="{{$ctrl.gapTooltipContent}}">
                                    <span>Existem períodos que não possuem configurações.</span>
                                    <i class="fa fa-exclamation-circle"></i>
                                </div>
                                <div 
                                    class="pis-cofins repeat-animation"
                                    ng-repeat="pisCofins in $ctrl.empresa.pisCofins" 
                                    ng-class="{'active': pisCofins.id === $ctrl.pisCofins.id, 'conflict': $ctrl.hasConflict(pisCofins)}"
                                    ng-click="$ctrl.selectPisCofins(pisCofins)">
                                    <span>
                                        <b>{{pisCofins.vigencia.from ? (pisCofins.vigencia.from | date: 'dd/MM/yyyy') : '...' }}</b> 
                                        a 
                                        <b>{{pisCofins.vigencia.to ? (pisCofins.vigencia.to | date: 'dd/MM/yyyy') : '...' }}</b>
                                    </span>  
                                </div>
                            </div>                            
                            <div class="pis-cofins-form">
                                <loading promise="$ctrl.promise" ng-if="$ctrl.pisCofins">
                                    <div ng-if="$ctrl.pisCofins.id" class="remover">
                                        <a href="javascript:void(0)" ng-click="$ctrl.removePisCofins($ctrl.pisCofins)">Remover</a>
                                    </div>
                                    <configuracao-pis-cofins
                                        empresa-id="$ctrl.resolve.empresaId"
                                        ng-if="$ctrl.pisCofins"
                                        pis-cofins="$ctrl.pisCofins" 
                                        filial-id="$ctrl.empresa.id"
                                        on-save="$ctrl.afterUpdatePisCofins(pisCofins)"
                                        on-errors="$ctrl.onErrors(pisCofins)"
                                        on-change="$ctrl.onChange(pisCofins)">
                                    </configuracao-pis-cofins>
                                </loading>


                                <div class="fallback" ng-if="!$ctrl.pisCofins">
                                    <highlighted>
                                        <main>Nenhuma configuração PIS/COFINS selecionada.</main>
                                        <secondary>Selecione uma configuração ou <a href="javascript:void(0)" ng-click="$ctrl.selectPisCofins()">clique aqui</a> para cadastar uma nova.</secondary>
                                    </highlighted>
                                </div>
                            </div>
                        </div>

                    </modal-body>
                    <modal-footer>
                        <button class="btn btn-default" type="button" ng-click="$ctrl.onClose()" ng-disabled="isLoading">Fechar</button>
                    </modal-footer>
                </modal>
            </promise-tracker>
        `
    })
